import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './../../app.component';

import { PqrRoutingModule } from './pqr-routing.module';

// Modules
import { SharedModule } from '@modules/shared.module';

//pipes
import { SearcherPipe } from '@pipes/searcher.pipe';

// Components
import { PqrComponent } from './pqr/pqr.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    PqrComponent,
    SearcherPipe
  ],
  imports: [
    CommonModule,
    SharedModule,
    PqrRoutingModule,
    FormsModule
  ],
  bootstrap: [AppComponent]
})
export class PqrModule { }